/**
 * Temporary client side Id generator for a to-be-created Entity.
 *
 * All client ids must start with the prefix cid_ in order for
 * them to be recognised as such and then discarded by the server.
 */
const generateClientId = (): string => 'lid_'.concat(Date.now().toString());

export default generateClientId;
